import React from "react";
import { H1, Link } from "@salt-ds/core";
import DefaultTabs from "./DefaultTabs";
import JPMorgan from "src/assets/JPMorgan.svg";
import Payments from "src/assets/Payments.svg";

const DefaultHeader = () => {
  return (
    <header className="sticky w-full top-0  h-[135px]  bg-white shadow flex-col  inline-flex z-10">
      <div className="mx-auto my-[20px]  w-[683px] h-8 justify-center items-center inline-flex ">
        <H1 styleAs="display3">Virtual Card (VC) Benefits</H1>
      </div>
      <div className="ml-[24px] absolute my-[25px]  w-[273px] gap-[16.58px] h-11 justify-start items-start inline-flex ">
        <div className="w-[161.08px] h-8 relative">
          <img src={JPMorgan} alt="JPMorgan" />
        </div>
        <div className="w-[69.86px] my-auto h-[10.62px] relative">
          <img src={Payments} alt="Payments" />
        </div>
      </div>
      <Link
        href="#mainContent"
        style={{ textDecoration: "underline" }}
        className="absolute mb-[57px] mt-[62px] ml-[24px] left-[-999px] top-0 focus:left-0 focus:top-0 focus:z-50 underline-offset-1 focus:text-skipLink p-2 "
      >
        Skip to Main Content
      </Link>
      <div className="mx-auto my-[29px]  w-[247.53px] h-8 pr-[0.01px] justify-center items-center gap-[16.58px] inline-flex  ">
        <DefaultTabs />
      </div>
    </header>
  );
};
export default DefaultHeader;
